import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';

import { environment } from '../../../environments/environment';
import { TurnoAsignado } from '../../models/Turno.model';
import { Sala } from '../../models/Sala.model';
import { AvisoMonitorDTO, MonitorStats } from '../../models/v2/TurnoV2.model';
import { CredentialsService } from '../local/credentials.service';
import { conectarCanalWs } from './canal-ws';

const { apiUrl } = environment;

type FilaSignal = {
  fila: TurnoAsignado[];
  close: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class SalaService {
  private httpClient = inject(HttpClient);
  private credentialsService = inject(CredentialsService);

  getTurnosDeSala(salaId: string): WritableSignal<FilaSignal> {
    const filaSignal: WritableSignal<FilaSignal> = signal({ fila: [], close: () => {} });
    let subscription: Subscription | null = null;
    const close = () => subscription?.unsubscribe();

    subscription = conectarCanalWs<TurnoAsignado[]>(`/ws/salas/${salaId}/turnos-asignados`, 'turnos-asignados')
      .subscribe(fila => filaSignal.set({ fila, close }));
    filaSignal.set({ fila: [], close });

    return filaSignal;
  }

  getSalas(sucursalId: number) {
    const credentials = this.credentialsService.credentials();
    return this.httpClient.get<Sala[]>(`${apiUrl}/salas?sucursalId=${sucursalId}`, {
      headers: {
        'Authorization': `Basic ${credentials}`
      }
    });
  }

  getSala(salaId: string): Observable<Sala> {
    const credentials = this.credentialsService.credentials();
    return this.httpClient.get<Sala>(`${apiUrl}/salas/${salaId}`, {
      headers: {
        'Authorization': `Basic ${credentials}`
      }
    })
  }

  getStats(salaId: string): Observable<MonitorStats> {
    const credentials = this.credentialsService.credentials();
    return this.httpClient.get<MonitorStats>(`${apiUrl}/salas/${salaId}/stats`, {
      headers: {
        'Authorization': `Basic ${credentials}`
      }
    })
  }

  getAvisos(salaId: string): Observable<AvisoMonitorDTO[]> {
    const credentials = this.credentialsService.credentials();
    return this.httpClient.get<AvisoMonitorDTO[]>(`${apiUrl}/salas/${salaId}/avisos`, {
      headers: {
        'Authorization': `Basic ${credentials}`
      }
    })
  }

}
